import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { WeekLessons } from "@/components/WeekLessons";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ClubsGrid } from "@/components/ClubsGrid";
import { ScheduleTable } from "@/components/ScheduleTable";
import { RegistrationForm } from "@/components/RegistrationForm";
import { Footer } from "@/components/Footer";
import { getSchool } from "@/data/clubs";

export default function Home() {
  const { school: schoolId } = useParams();
  const school = getSchool(schoolId);

  useEffect(() => {
    document.title = `${school.label} | חוגי ספורט והעשרה`;
    window.scrollTo(0, 0);
  }, [school.label]);

  return (
    <main data-testid="home-page" key={school.id}>
      <Navbar />
      <Hero schoolName={school.name} schoolId={school.id} regUrl={school.regUrl} />
      <WeekLessons schoolId={school.id} schoolName={school.name} />
      <EditorialMarquee />
      <ClubsGrid clubs={school.clubs} schoolId={school.id} regUrl={school.regUrl} />
      <ScheduleTable clubs={school.clubs} regUrl={school.regUrl} />
      <RegistrationForm schoolClubs={school.clubs} schoolName={school.name} regUrl={school.regUrl} />
      <Footer />
    </main>
  );
}
